import type { UpdatePaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const updateTransfer = createAsyncThunk<string, { id: string; body: UpdatePaymentBody }, { extra: Partial<Dependencies> }>(
  "transfers/updateTransfer",
  async ({ id, body }: { id: string; body: UpdatePaymentBody }, { extra: { adminRepository } }) => {
    return adminRepository!.updateTransfer(id, body);
  },
);

export const resetUpdateTransfer = createAction("transfers/resetUpdateTransfer");
